import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import { devConfig } from 'config/config'; // Import development configuration
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component

/**
 * Class representing the templates view.
 * @extends JetView
 */
export default class templatesView extends JetView {
    /**
     * Configures the layout of the templates view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const screen = this.app.config.size; // Current screen size configuration
        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            type: 'clean', // Clean layout type
            view: 'form', // Form view
            id: 'a10', // Unique identifier for the form
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    type: 'wide', // Wide layout type
                    responsive: 'a10', // Responsive layout identifier
                    margin: 10, // Margin around the layout
                    cols: [
                        {
                            localId: 'inner:layout', // Local identifier for the inner layout
                            gravity: 4, // Gravity for resizing
                            type: 'wide', // Wide layout type
                            rows: [
                                {
                                    view: 'tabbar', // Tab bar view
                                    localId: 'tabbar', // Local identifier for the tab bar
                                    options: [
                                        {
                                            id: 'partner.templates.email', // Identifier for email tab
                                            value: _('Email'), // Localized value for email
                                        },
                                        {
                                            id: 'partner.templates.sms', // Identifier for SMS tab
                                            value: _('SMS'), // Localized value for SMS
                                        },
                                        {
                                            id: 'partner.templates.pdf', // Identifier for PDF tab
                                            value: _('PDF'), // Localized value for PDF
                                        },
                                    ],
                                },
                                { $subview: true }, // Placeholder for subview
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the templates view.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use the Menu plugin with the tab bar
    }
}

// FILE DOCUMENTED
